import React from "react";
import { Media } from "react-bootstrap";
import PlaceholderImage from "../../../sharedComponents/placeholderImage";
import StartRating from "../../../sharedComponents/starRating";
import "../home.scss";
import NoContent from "../../../sharedComponents/noItemFoundAlert";

export default ({ list, onClick, className = "", type = "recipe" }) => {
	return (
		<div className={`content-container ${className}`}>
			{list && list.length ? (
				list.map((item) => (
					<Media key={item.id} className="mb-2 pointer" onClick={() => onClick(item)}>
						{type === "recipe" ? (
							<React.Fragment>
								<PlaceholderImage
									src={item.images && item.images.length ? item.images[0].image_data.photo_m : ""}
									width={40}
									height={40}
									color="rgba(0,0,0,0.3)"
									bg="rgba(0,0,0,0.1)"
									className="mr-3 img-custom-style"
								/>
								<Media.Body>
									<h5 className="mb-1">{item.name}</h5>
									<div className="notes-container">{item.notes ? item.notes : "--"}</div>
								</Media.Body>
							</React.Fragment>
						) : (
							<Media.Body>
								<div className="title-container">
									<h5 className="text-primary-dark mb-0">{item.title}</h5>
									<StartRating value={item.rating} />
								</div>
								<div className="notes-container">{item.notes}</div>
							</Media.Body>
						)}
					</Media>
				))
			) : (
				<NoContent />
			)}
		</div>
	);
};
